<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-dark m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <strong>Data Export to PDF</strong>
            </div>
          </div>
        </div>
      </div>
      <section class="">
        <div class="container">
          <div class="row list">
            <div class="col-lg-12 col-md-8">
              <div class="card m-b-30">
                <div class="card-body">
                  <FilterUserProvider />
                  <!-- <DownloadMDa /> -->
                  <DownloadProvider />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
// import DownloadMDa from "./components/downloadMda";
import DownloadProvider from "./component/DownloadProvider";
import FilterUserProvider from "./component/FilterUserProvider";

export default {
  components: {
    Navbar,
    Loading,
    DownloadProvider,
    FilterUserProvider,
  },
  data() {
    return {
      user: null,
      ministries: "",
      departments: "",
      parastatals: "",
      current_page: 1,
      edit: false,
      show: false,
      selector: "ministry",
      isLoading: false,
      fullPage: true,
      agency_id: "",
      provider_id: "",
      ministry_id: "",
      register: {
        ministry: "",
        department: "",
        parastatal: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/ministry`)
      .then((response) => {
        this.ministries = response.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  methods: {
    gotoNext() {
      if (this.ministries.meta.current_page != this.ministries.meta.last_page) {
        this.current_page++;
        this.getDepts();
      } else {
        this.$toasted.info("You have reached the Last Page", {
          position: "top-center",
          duration: 3000,
        });
      }
    },
    gotoPrevious() {
      if (this.ministries.meta.current_page != 1) {
        this.current_page--;
        this.getDepts();
      } else {
        this.$toasted.info("You have reached the First Page", {
          position: "top-center",
          duration: 3000,
        });
      }
    },
    getDepts() {
      this.axios
        .get(`/api/v1/auth/ministry`)
        .then((response) => {
          this.ministries = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    registerMDA() {
      this.isLoading = true;
      if (this.selector == "ministry") {
        this.axios
          .post("/api/v1/auth/ministry", {
            agency_id: 4,
            name: this.register.ministry,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.getDepts();
            this.clearIt();
            this.$toasted.info("MDA Added", {
              position: "top-center",
              duration: 5000,
            });
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.$toasted.error("Error", {
              position: "top-left",
              duration: 5000,
            });
          });
      }
      if (this.selector == "department") {
        this.axios
          .post("/api/v1/auth/department", {
            name: this.register.department,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.success("Department Added", {
              position: "top-left",
              duration: 5000,
            });
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.$toasted.error("Error", {
              position: "top-left",
              duration: 5000,
            });
          });
      }
      if (this.selector == "parastatal") {
        this.axios
          .post("/api/v1/auth/parastatars", {
            name: this.register.parastatal,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.success("Parastatal Added", {
              position: "top-left",
              duration: 5000,
            });
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.$toasted.error("Error", {
              position: "top-left",
              duration: 5000,
            });
          });
      }
    },

    clearIt() {
      this.register.ministry = "";
    },
  },
  created() {
    this.getDepts();
  },
};
</script>
